// misc/* page translations
const misc = {
  myPage: {
    title: 'My Page',
    subtitle: 'Manage my account information',
    editInfo: 'Edit Info',
    cancel: 'Cancel',
    save: 'Save',
    joinDate: 'Join Date',
    lastLogin: 'Last Login',
    basicInfo: 'Basic Information',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    department: 'Department',
    role: 'Role',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    currentPasswordPlaceholder: 'Enter current password',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'Enter new password (8+ characters)',
    confirmPassword: 'Confirm New Password',
    confirmPasswordPlaceholder: 'Re-enter new password',
    submitPassword: 'Change Password',
    passwordMismatch: 'New passwords do not match.',
    passwordChanged: 'Password has been changed.',
    defaultName: 'Kim Admin',
    defaultRole: 'System Administrator',
    defaultDepartment: 'IT Team',
  },
  notFound: {
    title: 'Page Not Found',
    message: 'The page you requested does not exist or has been moved.',
    goBack: 'Previous Page',
    goHome: 'Go Home',
  },
  modelDashboard: {
    title: 'Model Performance Dashboard',
    subtitle: 'Trained anomaly detection model status and performance analysis',
    summaryBtn: 'Summary',
    refresh: 'Refresh',
    gpuLive: 'GPU Live',
    mockData: 'Mock Data',
    errorPrefix: 'GPU server connection failed: {error}',
    loading: 'Loading data...',
    historyLoading: 'Loading training history...',
    noHistory: 'No training history',
    kpi: {
      lstm: 'LSTM Models',
      ae: 'AE Models',
      total: 'Total Models',
      totalData: 'Total Data Used',
      unitCount: '',
      unitRecords: '',
    },
    table: {
      modelId: 'Model ID',
      equipment: 'Equipment',
      mold: 'Mold',
      valLoss: 'Val Loss',
      accuracy: 'Accuracy',
      precision: 'Precision',
      recall: 'Recall',
      f1: 'F1',
      fpr: 'FPR',
      dataCount: 'Data Size',
      trainedAt: 'Trained At',
      empty: 'No trained models',
    },
    detail: {
      confusionMatrix: 'Confusion Matrix',
      predNormal: 'Pred: Normal',
      predAnomaly: 'Pred: Anomaly',
      actualNormal: 'Actual: Normal',
      actualAnomaly: 'Actual: Anomaly',
      tn: 'TN',
      fp: 'FP (False Positive)',
      fn: 'FN (False Negative)',
      tp: 'TP',
      validSample: 'Validation Samples',
      validSampleSuffix: '{n}',
      accuracyLabel: 'Accuracy',
      fprLabel: 'False Positive Rate (FPR)',
      trainThreshold: 'Train Threshold',
      valThreshold: 'Val Threshold',
      cmNote: '* Ground Truth: Val 95th percentile | Prediction: Train 95th percentile',
      trainingCurve: 'Training Curve',
      totalEpoch: 'Total {n} Epochs',
      convergence: 'Convergence: {n} Epoch',
      finalValLoss: 'Final Val Loss: {n}',
      reduction: 'Reduction: {n}%',
    },
    summary: {
      title: 'Anomaly Detection Model Performance Summary',
      subtitle: 'Smart Injection Monitoring - AI Model Performance Report',
      totalModels: 'Total Models',
      totalData: 'Total Training Data',
      lstmCount: 'LSTM Models',
      aeCount: 'AE Models',
      modelCount: '{n} models',
      avgAccuracy: 'Avg. Accuracy',
      avgPrecision: 'Avg. Precision',
      avgRecall: 'Avg. Recall',
      avgF1: 'Avg. F1 Score',
      trainData: 'Training Data',
      retrainNeeded: 'Retraining needed',
      footerNote: 'Confusion Matrix: Ground Truth = Val 95th Percentile, Prediction = Train 95th Percentile Threshold',
      unitCount: '',
      unitRecords: '',
    },
  },
};

export default misc;
